import React, { useState, useEffect } from "react";
import {
    Paper,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Button,
    Divider,
} from "@material-ui/core";
import { List as ListIcon, Save } from "@material-ui/icons";
import { API } from "../../config";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
// import PageHeader from "../../components/sidebar/PageHeader";

const MenuManagement = () => {
    const { NotifyMessage, notify, setNotify } = Notify();
    const [roles, setRoles] = useState([]);
    const [allMenus, setAllMenus] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState("");
    const [selectedMenuIds, setSelectedMenuIds] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchRoles();
        fetchMenus();
    }, []);

    const fetchRoles = () => {
        fetch(`${API}/roles`)
            .then((res) => res.json())
            .then((data) => setRoles(data.data));
    };

    const fetchMenus = () => {
        fetch(`${API}/menus`)
            .then((res) => res.json())
            .then((data) => setAllMenus(data.data));
    };

    const fetchRoleMenus = (roleId) => {
        if (!roleId) return;
        setLoading(true);
        fetch(`${API}/role-menus/${roleId}`)
            .then((res) => res.json())
            .then((data) => {
                const menuIds = data.data.map((m) => m.id);
                setSelectedMenuIds(menuIds);
                setLoading(false);
            });
    };

    const handleRoleChange = (e) => {
        const roleId = e.target.value;
        setSelectedRoleId(roleId);
        fetchRoleMenus(roleId);
    };

    const handleToggleMenu = (menuId) => {
        const currentIndex = selectedMenuIds.indexOf(menuId);
        const newChecked = [...selectedMenuIds];

        if (currentIndex === -1) {
            newChecked.push(menuId);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSelectedMenuIds(newChecked);
    };

    const handleSaveAssignments = () => {
        if (!selectedRoleId) {
            NotifyMessage({ message: "Please select a role first", type: "error" });
            return;
        }
        setLoading(true);
        fetch(`${API}/role-menus`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ roleId: selectedRoleId, menuIds: selectedMenuIds }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.err) throw new Error(data.err);
                NotifyMessage({ message: data.message, type: "success" });
                setLoading(false);
            })
            .catch((err) => {
                NotifyMessage({ message: err.message || "Error saving assignments", type: "error" });
                setLoading(false);
            });
    };

    return (
        <Layout>
            <Admin>
                <div style={{ padding: 20 }} className="card">
                    <Typography variant="h6" className="page-header">
                        Menu Management
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Paper style={{ padding: 20 }}>
                                <Typography variant="h6" gutterBottom>Select Role</Typography>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Role</InputLabel>
                                    <Select value={selectedRoleId} onChange={handleRoleChange} label="Role">
                                        {roles.map((role) => (
                                            <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    startIcon={<Save />}
                                    style={{ marginTop: 20 }}
                                    onClick={handleSaveAssignments}
                                    disabled={loading || !selectedRoleId}
                                >
                                    Save Assignments
                                </Button>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Paper style={{ padding: 20 }}>
                                <Typography variant="h6" gutterBottom>Available Menus</Typography>
                                <Divider />
                                <List style={{ maxHeight: 400, overflow: 'auto' }}>
                                    {allMenus.length === 0 && <Typography variant="body2" color="textSecondary">No menus found in database. Please ensure Menus table is populated.</Typography>}
                                    {allMenus.map((menu) => (
                                        <ListItem key={menu.id} button onClick={() => handleToggleMenu(menu.id)}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={selectedMenuIds.indexOf(menu.id) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary={menu.menuName} secondary={menu.route} />
                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>
                        </Grid>
                    </Grid>
                    <Notification notify={notify} setNotify={setNotify} />
                </div>
            </Admin>
        </Layout>
    );
};

export default MenuManagement;
